<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">作業列表</h1>
        <p class="page-subtitle">管理作業信息，支援新增、複製、編輯、刪除、預覽等功能</p>
      </div>
      <div class="header-right">
        <el-button
            size="small"
            type="warning"
            @click="onAdd"
            icon="el-icon-plus"
        >
          新增作業
        </el-button>
      </div>
    </div>

    <div class="layout">
      <!-- 筛选搜索区 -->
      <div class="search-card">
        <!-- PC端筛选栏（≥768px显示） -->
        <div class="pc-search">
          <div class="search-row">
            <div v-if="userInfoRoleRoleId == siteAdminRoleId" class="search-item">
              <div class="search-text">分校</div>
              <el-select
                  v-model="formLabelAlign.branchSchoolsId"
                  placeholder="全部"
                  filterable
                  ref="branchSchoolSelect"
                  :filter-method="filterBranchSchool"
                  clearable
                  size="small"
              >
                <el-option
                    v-for="(item) in filteredBranchSchools"
                    :key="item.id"
                    :label="`${item.abbreviation || ''}${item.nameZh || ''}`"
                    :value="item.id"
                    :title="`${item.abbreviation || ''}${item.nameZh || ''}`"
                ></el-option>
              </el-select>
            </div>
            <div class="search-item">
              <div class="search-text">創建人</div>
              <el-input
                  v-model="formLabelAlign.createdNameLike"
                  placeholder="請輸入創建人"
                  size="small"
                  clearable
              ></el-input>
            </div>
            <div class="search-item">
              <div class="search-text">作業編號</div>
              <el-input
                  v-model="formLabelAlign.numberLike"
                  placeholder="請輸入作業編號"
                  size="small"
                  clearable
              ></el-input>
            </div>
            <div class="search-item">
              <div class="search-text">作業名稱</div>
              <el-input
                  v-model="formLabelAlign.name"
                  placeholder="請輸入作業名稱"
                  size="small"
                  clearable
              ></el-input>
            </div>
            <div class="search-item">
              <div class="search-text">年級</div>
              <el-select
                  v-model="formLabelAlign.gradeId"
                  placeholder="全部"
                  size="small"
                  clearable
              >
                <el-option
                    v-for="(item, index) in grades"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="search-item">
              <div class="search-text">課程版本</div>
              <el-select
                  v-model="formLabelAlign.lang"
                  placeholder="全部"
                  size="small"
                  clearable
              >
                <el-option
                    v-for="item in languages"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-item search-button">
              <el-button size="small" type="warning" @click="onSearch">
                搜尋全部
              </el-button>
            </div>
            <div class="search-item search-button">
              <el-button size="small" @click="onSearchMy">
                我的創建
              </el-button>
            </div>
          </div>
        </div>

        <!-- 移动端筛选栏（<768px显示） -->
        <div class="mobile-search">
          <el-collapse>
            <el-collapse-item title="篩選條件" name="1">
              <div class="mobile-search-form">
                <el-form size="small" label-width="100px">
                  <el-form-item label="作業編號">
                    <el-input
                        v-model="formLabelAlign.numberLike"
                        placeholder="請輸入作業編號"
                        clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="作業名稱">
                    <el-input
                        v-model="formLabelAlign.name"
                        placeholder="請輸入作業名稱"
                        clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="分校" v-if="userInfoRoleRoleId == siteAdminRoleId">
                    <el-select
                        v-model="formLabelAlign.branchSchoolsId"
                        placeholder="全部"
                        filterable
                        ref="branchSchoolSelect"
                        :filter-method="filterBranchSchool"
                        clearable
                    >
                      <el-option
                          v-for="(item) in filteredBranchSchools"
                          :key="item.id"
                          :label="`${item.abbreviation || ''}${item.nameZh || ''}`"
                          :value="item.id"
                          :title="`${item.abbreviation || ''}${item.nameZh || ''}`"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="年級">
                    <el-select
                        v-model="formLabelAlign.gradeId"
                        placeholder="全部"
                        clearable
                    >
                      <el-option
                          v-for="(item, index) in grades"
                          :key="index"
                          :label="item.name"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                        v-model="formLabelAlign.lang"
                        placeholder="全部課程版本"
                        clearable
                    >
                      <el-option
                          v-for="item in languages"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <div class="mobile-search-buttons">
                      <el-button type="warning" @click="onSearch" style="width: 48%;">
                        搜尋全部
                      </el-button>
                      <el-button type="success" @click="onSearchMy" style="width: 48%;">
                        我的創建
                      </el-button>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>

      <!-- 数据展示区 -->
      <div class="data-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="tableData"
              style="width: 100%"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無作業數據' : ''"
          >
            <el-table-column
                prop="number"
                label="作業編號"
                align="center"
                sortable="custom"
            >
            </el-table-column>
            <el-table-column
                prop="name"
                label="作業名稱"
                align="center"
                sortable="custom"
            >
            </el-table-column>
            <el-table-column
                prop="branchSchoolsAbbreviation"
                label="分校"
                align="center"
                sortable="custom"
            ></el-table-column>
            <el-table-column
                prop="createdName"
                label="創建人"
                align="center"
                sortable="custom"
            >
            </el-table-column>
            <el-table-column
                prop="gradeId"
                label="年級"
                align="center"
                sortable="custom"
            >
              <template slot-scope="{row}">
                <span>{{row.gradeName}}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="lang"
                label="課程版本"
                align="center"
            >
              <template slot-scope="{row}">
                <el-tag size="mini" :type="row.lang === 0 ? 'info' : 'success'">
                  {{row.lang | language}}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column
                prop="startDate"
                label="開始日期"
                align="center"
                sortable="custom"
            >
              <template slot-scope="{row}">
                <span>{{row.startDate | formatDate}}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="endDate"
                label="結束日期"
                align="center"
                sortable="custom"
            >
              <template slot-scope="{row}">
                <span>{{row.endDate | formatDate}}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="updatedAt"
                label="最後更新時間"
                align="center"
                sortable="custom"

            >
              <template slot-scope="{row}">
                <span>{{row.updatedAt | formatDateTime}}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="editor"
                label="最後更新帳號"
                align="center"

            >
              <template slot-scope="{row}">
                <span>{{row.editor || '-'}}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="studentNameStr"
                label="學生"
                align="center"
                sortable="custom"
            >
              <!-- 自定义模板插槽，实现文本截断+悬浮提示 -->
              <template slot-scope="scope">
                <el-tooltip
                    :content="scope.row.studentNameStr"
                    placement="top"
                    effect="dark"
                >
                  <span class="text-truncate-10">{{ scope.row.studentNameStr }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
                prop="progress"
                label="完成人數/佈置總數"
                align="center"
                sortable="custom"
            >
            </el-table-column>
            <el-table-column label="操作"  align="center" min-width="250">
              <template slot-scope="{ row }">
                <div class="operation-group">
                  <el-button type="text" size="small" @click="onCopyButton(row.id)"
                             icon="el-icon-copy-document" class="copy-btn"
                  >複製</el-button
                  >
                  <el-button type="text" size="small" @click="onEditButton(row.id)"
                             icon="el-icon-edit" class="edit-btn"
                  >編輯</el-button
                  >
                  <el-button v-if="userInfoRoleRoleId !=teacherRoleId && userInfoRoleRoleId !=editorRoleId" type="text" size="small" @click="onDeleteButton(row.id)"
                             icon="el-icon-delete" class="delete-btn"
                  >刪除</el-button
                  >
                  <el-button
                      type="text"
                      size="small"
                      @click="onDetailButton(row.id)"
                      icon="el-icon-view" class="detail-btn"
                  >詳情</el-button
                  >
                  <el-button type="text" size="small" @click="downloadPdf(row.number, row.id)"
                             icon="el-icon-download" class="pdf-btn"
                  >預覽</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="homework-card" v-for="(row, index) in tableData" :key="row.id || index">
            <!-- 卡片头部：作业编号 + 基础信息 -->
            <div class="card-header">
              <div class="homework-number">{{ row.number }}</div>
              <div class="homework-badges">
                <el-tag size="mini" type="warning">{{ row.branchSchoolsAbbreviation || '未知分校' }}</el-tag>
                <el-tag size="mini" type="success">{{ row.gradeName || '未知年級' }}</el-tag>
                <el-tag size="mini" :type="row.lang === 0 ? 'info' : 'success'">
                  {{ row.lang | language }}
                </el-tag>
              </div>
            </div>

            <!-- 卡片主体 -->
            <div class="card-body">
              <div class="homework-meta">
                <div class="meta-item">
                  <i class="el-icon-user"></i>
                  <span>創建人：{{ row.createdName || '-' }}</span>
                </div>
                <div class="meta-item">
                  <i class="el-icon-date"></i>
                  <span>開始日期：{{ row.startDate | formatDate }}</span>
                </div>
                <div class="meta-item">
                  <i class="el-icon-date"></i>
                  <span>結束日期：{{ row.endDate | formatDate }}</span>
                </div>
                <div class="meta-item">
                  <i class="el-icon-time"></i>
                  <span>最後更新：{{ row.updatedAt | formatDateTime }}</span>
                </div>
                <div class="meta-item" v-if="row.editor">
                  <i class="el-icon-user"></i>
                  <span>更新帳號：{{ row.editor }}</span>
                </div>
                <div class="meta-item">
                  <i class="el-icon-user-solid"></i>
                  <span>學生：</span>
                  <el-tooltip
                      :content="row.studentNameStr"
                      placement="top"
                      effect="dark"
                  >
                    <span class="text-truncate-8">{{ row.studentNameStr || '-' }}</span>
                  </el-tooltip>
                </div>
                <div class="meta-item">
                  <i class="el-icon-s-data"></i>
                  <span>完成進度：{{ row.progress || '-' }}</span>
                </div>
              </div>
            </div>

            <!-- 卡片操作栏 -->
            <div class="card-actions">
              <div class="action-group">
                <el-button type="text" size="mini" @click="onCopyButton(row.id)"
                           icon="el-icon-copy-document" class="copy-btn"
                >複製</el-button>
                <el-button type="text" size="mini" @click="onEditButton(row.id)"
                           icon="el-icon-edit" class="edit-btn"
                >編輯</el-button>
                <el-button v-if="userInfoRoleRoleId !=teacherRoleId && userInfoRoleRoleId !=editorRoleId" type="text" size="mini" @click="onDeleteButton(row.id)"
                           icon="el-icon-delete" class="delete-btn"
                >刪除</el-button>
                <el-button type="text" size="mini" @click="onDetailButton(row.id)"
                           icon="el-icon-view" class="detail-btn"
                >詳情</el-button>
                <el-button type="text" size="mini" @click="downloadPdf(row.number, row.id)"
                           icon="el-icon-download" class="pdf-btn"
                >預覽</el-button>
              </div>
            </div>
          </div>

          <!-- 空数据提示 -->
          <div class="empty-tip" v-if="tableData.length === 0">
            <i class="el-icon-document-empty"></i>
            <p>暫無作業數據</p>
            <el-button
                size="small"
                type="warning"
                @click="onAdd"
                icon="el-icon-plus"
            >
              立即新增
            </el-button>
          </div>
        </div>
      </div>

      <!-- 分页组件 -->
      <div class="pagination-container" v-show="total > 0">
        <Pagination
            :total="total"
            :page.sync="formLabelAlign._page"
            :limit.sync="formLabelAlign._limit"
            @pagination="getHomeworks"
        />
      </div>
    </div>

    <!-- 删除弹窗 -->
    <deleteDialog
        titleCh="您確定要刪除此作業嗎？"
        :centerDialogVisible="centerDialogVisible"
        @confirmFunction="confirmFunction"
        @onCancelButton="onCancelButton"
    ></deleteDialog>


    <el-dialog
        :visible.sync="examination_switch"
        width="80%"
        margin-top="5px">
      <!-- PDF导出遮罩 -->
      <examination ref="examination"></examination>
      <span slot="footer" class="dialog-footer">
    <el-button @click="examination_switch = false">關閉</el-button>
  </span>
    </el-dialog>
    <!-- 加载弹窗 -->
    <loadingDialog :center-dialog-visible="loading_switch" loading-text="正在匯出。。。">正在匯出。。。</loadingDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { payStatus } from "@/biz/static-data";
import { getHomeworks, deleteHomeworks } from "@/api/homeworks";
import deleteDialog from "@/components/deleteDialog";
import examination from "./components/examination.vue";
import loadingDialog from "@/components/loadingDialog/index";
import { getGrades } from '@/api/grade'

export default {
  components: { deleteDialog, Pagination, examination, loadingDialog },
  filters: {
    // 日期格式化
    formatDate(value) {
      if (!value) return '未設定';
      const date = new Date(value);
      return `${date.getFullYear()}-${(date.getMonth()+1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    },
    // 日期时间格式化
    formatDateTime(value) {
      if (!value) return '未設定';
      const date = new Date(value);
      return `${date.getFullYear()}-${(date.getMonth()+1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    },
    // 语言转换
    language(value) {
      const langMap = {
        0: '中文',
        1: '英文',
        null: '全部',
        undefined: '未知'
      };
      return langMap[value] || '未知';
    }
  },
  data() {
    return {
      // 角色权限
      userInfoRoleRoleId: this.$store.getters.userInfo?.role?.roleId || '',
      siteAdminRoleId: this.$store.getters.roleConfig?.siteAdminRoleId || '',
      teacherRoleId: this.$store.getters.roleConfig?.teacherRoleId || '',
      editorRoleId: this.$store.getters.roleConfig?.editorRoleId || '',

      // 语言选项
      languages: [
        { label: "全部", value: null },
        { label: "中文", value: 0 },
        { label: "英文", value: 1 }
      ],

      loadingMsg: '正在匯出。。。',
      itemId: 0,
      total: 0,
      payStatus: [],
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      formLabelAlign: {
        numberLike: null,
        createdNameLike: null,
        name: null,
        gradeId: null,
        branchSchoolsId: null,
        createdId: null,
        lang: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      tableData: [],
      grades: [],
      filteredBranchSchools: [],
      examination_switch: false,
      loading_switch: false
    };
  },
  created() {
    this.payStatus = payStatus;
    this.getHomeworks();
    this.getGrades();
    // 初始化时加载全部校区列表
    this.filteredBranchSchools = this.$store.getters.branchSchools || [];
  },
  methods: {
    // 路由跳转封装
    resolveRouter(path) {
      window.open(this.$router.resolve({ path }).href, '_self');
    },
    // 自定义筛选方法：根据输入关键词匹配校区缩写
    filterBranchSchool(val) {
      // 1. 兜底获取分校列表，避免 null/undefined
      const branchSchools = this.$store.getters.branchSchools || [];

      if (!val) {
        // 输入为空时显示全部
        this.filteredBranchSchools = branchSchools;
      } else {
        // 2. 统一转小写+去除首尾空格，保证匹配一致性
        const searchText = val.toLowerCase().trim();

        // 3. 同时匹配 abbreviation 和 nameZh（都做空值兜底）
        this.filteredBranchSchools = branchSchools.filter(item => {
          // 空值兜底：避免 item.abbreviation/nameZh 为 null/undefined 时报错
          const abbreviation = (item.abbreviation || '').toLowerCase();
          const nameZh = (item.nameZh || '').toLowerCase();
          const nameEn = (item.nameEn || '').toLowerCase();
          // 满足任意一个字段匹配即可
          return abbreviation.includes(searchText) || nameZh.includes(searchText) || nameEn.includes(searchText);
        });
      }
    },
    // 下载PDF
    downloadPdf(title, id) {
      this.examination_switch = true;
      this.$nextTick(() => {
        // this.loading_switch = true;
        let examination = this.$refs.examination;
        examination.init(title, id);
      });
    },
    // 删除按钮
    onDeleteButton(id) {
      this.itemId = id;
      this.centerDialogVisible = true;
    },
    // 排序处理
    handleSortChange(column) {
      if (column.order === "descending") {
        this.formLabelAlign.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.formLabelAlign.orderBy = column.prop + " asc";
      } else {
        this.formLabelAlign.orderBy = null;
      }
      this.formLabelAlign._page = 1;
      this.getHomeworks();
    },
    // 重置筛选
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if (key === "_page") {
          this.formLabelAlign[key] = 1;
        } else if (key === "_limit") {
          this.formLabelAlign[key] = 10; // 保持默认10条
        }
      });
      this.getHomeworks();
    },
    // 搜索全部
    onSearch() {
      this.formLabelAlign.createdId = null;
      this.formLabelAlign._page = 1; // 搜索后回到第一页
      this.getHomeworks();
    },
    // 搜索我创建的
    onSearchMy() {
      this.formLabelAlign.createdId = this.$store.getters.adminUserInfo.userId;
      this.formLabelAlign._page = 1; // 搜索后回到第一页
      this.getHomeworks();
    },
    // 取消删除
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    // 确认删除
    confirmFunction() {
      const loading = this.$loading({
        lock: true,
        text: '刪除中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.deleteHomeworks()
          .finally(() => {
            loading.close();
          });
    },
    // 新增作业
    onAdd() {
      this.resolveRouter(`/job/add`);
    },
    // 复制作业
    onCopyButton(id) {
      if (!id) {
        this.$message.warning("作業ID不存在，無法複製");
        return;
      }
      this.resolveRouter(`/job/${id}/copy`);
    },
    // 编辑作业
    onEditButton(id) {
      if (!id) {
        this.$message.warning("作業ID不存在，無法編輯");
        return;
      }
      this.resolveRouter(`/job/${id}/edit`);
    },
    // 查看详情
    onDetailButton(id) {
      if (!id) {
        this.$message.warning("作業ID不存在，無法查看詳情");
        return;
      }
      this.resolveRouter(`/job/${id}`);
    },
    // 删除作业
    deleteHomeworks() {
      return deleteHomeworks(this.itemId)
          .then(() => {
            this.$message.success('刪除成功');
            this.getHomeworks();
          })
          .catch(err => {
            console.error('删除作业失败：', err);
            this.$message.error('刪除失敗，請稍後重試');
          })
          .finally(() => {
            this.centerDialogVisible = false;
          });
    },
    // 获取年级列表
    getGrades() {
      getGrades()
          .then((v) => {
            this.grades = v.data || [];
          })
          .catch(err => {
            console.error('获取年级列表失败：', err);
            this.$message.error('獲取年級列表失敗');
          });
    },
    // 获取作业列表
    getHomeworks() {
      const loading = this.$loading({
        lock: true,
        text: '加載作業數據中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let formLabelAlign = {
        numberLike: this.formLabelAlign.numberLike,
        createdNameLike: this.formLabelAlign.createdNameLike,
        name: this.formLabelAlign.name,
        gradeId: this.formLabelAlign.gradeId,
        createdId: this.formLabelAlign.createdId,
        branchSchoolsId: this.formLabelAlign.branchSchoolsId,
        lang: this.formLabelAlign.lang,
        orderBy: this.formLabelAlign.orderBy,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };

      getHomeworks(formLabelAlign)
          .then((v) => {
            this.tableData = v.data || [];
            this.total = Number(v.headers["x-total-count"]) || 0;
          })
          .catch(err => {
            console.error('获取作业列表失败：', err);
            this.$message.error('獲取作業列表失敗，請稍後重試');
            this.tableData = [];
            this.total = 0;
          })
          .finally(() => {
            loading.close();
          });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
  position: relative; /* 为mask定位 */
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  //padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 22px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
    .page-subtitle {
      font-size: 14px;
      color: #6c757d;
      margin: 0;
    }
  }

  .header-right {
    display: flex;
    gap: 12px;
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  //padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 搜索卡片样式 */
.search-card {
  //margin-bottom: 20px;

  /* PC端搜索样式 */
  .pc-search {
    .search-row {
      display: grid;
      grid-template-columns: repeat(4, 1fr) 120px 120px;
      gap: 12px;
      padding: 16px;
      background: #f8f9fa;
      border-radius: 6px;

      .search-item {
        .search-text {
          margin-bottom: 4px;
          font-size: 12px;
          color: #6c757d;
          font-weight: 500;
        }
      }

      .search-button {
        display: flex;
        align-items: flex-end;

        .el-button {
          width: 100%;
        }
      }
    }
  }

  /* 移动端搜索样式 */
  .mobile-search {
    display: none;

    .mobile-search-form {
      padding: 16px 8px;
    }

    .mobile-search-buttons {
      display: flex;
      justify-content: space-between;
      gap: 8px;
    }
  }
}

/* 数据容器样式 */
.data-container {
  width: 100%;
  //margin-bottom: 20px;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep {
      .el-table {
        --el-table-header-text-color: #4e5969;
        --el-table-row-hover-bg-color: #f8f9fa;
      }

      .el-table th {
        background: #f8f9fa;
        font-weight: 600;
      }

      .operation-group {
        display: flex;
        justify-content: center;
        gap: 6px;
        flex-wrap: wrap;
      }

      .copy-btn {
        color: #67c23a;
      }

      .edit-btn {
        color: #409eff;
      }

      .delete-btn {
        color: #f56c6c;
      }

      .detail-btn {
        color: #166ea5;
      }

      .pdf-btn {
        color: #e6a23c;
      }

      // 兼容Element UI表格单元格样式
      .el-table .cell {
        overflow: visible !important;  // 避免表格单元格截断tooltip
      }
    }
  }

  /* 手机端卡片样式 */
  .mobile-cards {
    display: none;
    flex-direction: column;
    gap: 16px;

    /* 作业卡片 */
    .homework-card {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 16px;
      border: 1px solid #e9ecef;
      transition: all 0.2s ease;

      &:hover {
        border-color: #166ea5;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      }

      /* 卡片头部 */
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #e9ecef;

        .homework-number {
          font-size: 18px;
          font-weight: 600;
          color: #166ea5;
        }

        .homework-badges {
          display: flex;
          gap: 6px;
          flex-wrap: wrap;
        }
      }

      /* 卡片主体 */
      .card-body {
        margin-bottom: 12px;

        .homework-meta {
          display: flex;
          flex-direction: column;
          gap: 8px;

          .meta-item {
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 12px;
            color: #6c757d;

            i {
              font-size: 12px;
              color: #166ea5;
              width: 14px;
              text-align: center;
            }
          }
        }
      }

      /* 卡片操作栏 */
      .card-actions {
        padding-top: 12px;
        border-top: 1px solid #e9ecef;

        .action-group {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          justify-content: center;
        }
      }
    }

    /* 空数据提示 */
    .empty-tip {
      text-align: center;
      padding: 40px 20px;
      color: #999;

      i {
        font-size: 48px;
        margin-bottom: 16px;
        display: block;
        color: #ced4da;
      }

      p {
        font-size: 16px;
        margin: 0 0 20px 0;
      }
    }
  }
}

/* 分页容器 */
.pagination-container {
  text-align: right;
  padding: 10px 0;
}

/* PDF导出遮罩 */
.mask {
  position: fixed; /* 修改为fixed，全屏覆盖 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: rgba(135, 206, 235, 0.8); /* 半透明 */
}

/* 文本截断样式 */
.text-truncate-10 {
  display: inline-block;
  max-width: 10em;          // 按字符宽度限制（1em≈1个字符）
  width: 100%;
  white-space: nowrap;      // 禁止换行
  overflow: hidden;         // 隐藏超出内容
  text-overflow: ellipsis;  // 超出显示省略号
  cursor: pointer;          // 鼠标悬浮显示手型，提示可交互
}

.text-truncate-8 {
  display: inline-block;
  max-width: 8em;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding-bottom: 12px;
  }

  .layout {
    padding: 16px;
  }

  /* 隐藏PC搜索，显示移动端搜索 */
  .search-card .pc-search {
    display: none;
  }
  .search-card .mobile-search {
    display: block;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .data-container .pc-table {
    display: none;
  }
  .data-container .mobile-cards {
    display: flex;
  }

  /* 分页适配 */
  .pagination-container {
    text-align: center;
  }
}

/* 适配平板屏幕 */
@media (min-width: 769px) and (max-width: 1024px) {
  .layout {
    padding: 20px;
  }

  .search-row {
    grid-template-columns: repeat(2, 1fr) 120px 120px !important;
  }
}
</style>